export enum LearningType {
  flashcards,
  multiplechoice,
  spellingQuiz,
}
